<template>
	<div class="parent" style="height:calc(100vh - 50px);">
		<dialogue
		:title="'Delete'"
		:paragraph="'Are you sure you want to delete Techdoc '+term+'?'"
		:button_names="['Delete']"
		:show="delete_dialogue"
		v-on:dialogue="deleteTechdoc"
		v-on:cancel="cancelDelete"
		></dialogue>
		<dialogue
		:title="'Saved'"
		:paragraph="'Techdoc '+term+' has been saved'"
		:button_names="['Accept']"
		:show="save_dialogue"
		v-on:cancel="cancelSave"
		></dialogue>

		<div>
			<div class="scroll" style="width:30%; height:calc(100vh - 75px); float:left;">
				<table>
					<tr>
						<td>
							<b style="white-space:nowrap;">File Name</b>
						</td>
						<td style="width:90%">
							<input style="width:100%" v-model="filename"></input>
						</td>
					</tr>
					<tr>
						<td>
							<b style="white-space:nowrap;">Notes</b>
						</td>
						<td>
							<textarea style="width:100%; min-height:30px; height:60px; max-height:125px;" v-model="notes"></textarea>
						</td>
					</tr>
				</table>
			</div>

			<div class="scroll" style="width:65%; height:calc(100vh - 75px); float:right;">
				<techdoc
					ref="doc"
					:id="parseInt(term)"
					:techdoc_id="term"
					:pageid="pageid"
					v-on:load="setData"
					style="width:100%; height:calc(95%);">
				</techdoc>
			</div>
		</div>

		<div class="nav-bar">
			<div>
				<button v-if="perms.includes('61')" v-on:click="saveTechdoc()">Save</button>
				<button v-if="perms.includes('61')" v-on:click="deleteTechdocDialogue()">Delete</button>
			</div>
		</div>
	</div>
</template>

<script>
import {PAGES} from './../../../constants.js'
import api from '@/api'
import router from '@/router/index'
export default {
    props: {
		term: ''
    },
	data(){
		return{
			pageid:PAGES.EDIT_TECHDOCS_PAGE,
			filename:'',
			notes:'',
			delete_dialogue:false,
			save_dialogue:false,
		}
	},
	async created () {
		this.perms = api.getPerms();
	},
	methods:{
		async cancelSave(){
			this.save_dialogue=false;
		},
		async saveTechdocDialogue(){
			this.save_dialogue=true;
		},
		async saveTechdoc (){
			api.postData(
				{
					type:"insert",
					data:{
						delete:false,
						pageid:this.pageid,
						data:[this.term, this.filename, this.notes]
					}
				}
			).then((res) => {
				this.saveTechdocDialogue()
			});
		},
		async cancelDelete(){
			this.delete_dialogue=false;
		},
		async deleteTechdocDialogue(){
			this.delete_dialogue=true;
		},
		async deleteTechdoc (){
			api.postData(
				{
					type:"insert",
					data:{
						delete:true,
						pageid:this.pageid,
						data:[this.term]
					}
				}
			).then((res) => {
				router.go(-1);
			});
		},
		setData(filename,notes){
			this.filename = filename
			this.notes = notes
		},
	}
}
</script>

<style scoped>
.box{
    margin-right: 25%;
    margin-left: 25%;
    margin-top: 55px;
    text-align:center;
}

.field{
    padding:10px;
    text-align:center;
}

.textlabel{
    white-space:nowrap;
    color:#35495E;
}

.textfield{
    width:100%;
}

.title{
    font-size:30px;
    font-weight:bold;
    color:#35495E;
}

.smalltext{
    font-size: 12px;
	color: #888888;
}

.upload-box{
    width:75%;
}

.custom-file-input ~ .custom-file-label::after {
  content: 'sh';
}

table {
    table-layout:auto;
    margin:auto;
    width:100%;
    border: none;
}
td {
    border: none;
}

</style>



// WEBPACK FOOTER //
// src/components/edit/Edit_Techdocs.vue